import { Navigate, Outlet, useLocation } from "react-router-dom";
import { TOKEN_KEY } from "../config";

function RoleBasedRoute({ allowedRoles }) {
  const location = useLocation();
  let token = sessionStorage.getItem(TOKEN_KEY);
  let userRole = sessionStorage.getItem("roles");

  // If no token, redirect to login
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user doesn't have required role, redirect to dashboard
  if (!allowedRoles.includes(userRole)) {
    // Redirect on role
    if (userRole === "admin") {
      return <Navigate to="/dashboard" replace />;
    } else if (userRole === "user") {
      return <Navigate to="/user-dashboard" replace />;
    } else if (userRole === "brand_handler") {
      return <Navigate to="/dashboard" replace />;
    }
    // If no matching role, redirect to login
    return <Navigate to="/" replace />;
  }

  // If role and token, render component
  return <Outlet />;
}

export default RoleBasedRoute;
